import { legacy_createStore as createStore } from 'redux'

const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: localStorage.getItem('sidebarUnfoldable') === 'true' || false,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':

    if(rest.sidebarUnfoldable !== undefined) {
      localStorage.setItem('sidebarUnfoldable', rest.sidebarUnfoldable)
    }

      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
